import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Card,
} from "@mui/material";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";
import { connect } from "react-redux";
import TabBoxComponent from "components/UI/TabBox";
import { TabPanel } from "./Meeting";
import RoomsManagement from "./RoomsManagement";
import ViewAllRoomsCalendar from "views/meeting/meeting/ViewAllRoomsCalendar";
import { errorToast } from "helpers/Notification";
import axios from "axios";

function Room({ SetSelectedMenu, systemSettings, location, FetchDetails }) {
    const [selectedTab, setSelectedTab] = useState(0);
    const [tabValue, setTabValue] = useState(location?.state?.tab ?? 0);
    const [employees, setEmployees] = React.useState([])


    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setTabValue(newValue);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "room",
            title: "Room Management",
        });
    }, [SetSelectedMenu]);

    const loadResources = async () => {
        try {
            // const resp = await axios.get('/api/resource/listAll');
            const resp = await axios.get('/api/request/list/resources');
            // console.log("resp: ", resp?.data.data)
            setEmployees(resp?.data.data)
        }
        catch (error) {
            errorToast("Error loading resources");
        }
    }
    useEffect(() => {
        loadResources()
    }, [])

    return (
        <Card className={"overflow-auto mt-3 "} variant={"outlined"}>
            <div className={"card-body mt-0 pt-0"}>
                <Box
                    sx={{ borderBottom: 1, borderColor: "divider" }}
                    className="flex flex-col p-3"
                >
                    <div className="flex justify-between items-center">
                        <TabBoxComponent
                            selectedValue={selectedTab}
                            handleTabChange={handleTabChange}
                            tabList={[
                                {
                                    label: "Meeting Calendar",
                                    tabValue: 0,
                                    permissionCode: "menu.meeting",
                                },
                                {
                                    label: "Room Management",
                                    tabValue: 1,
                                    permissionCode: "submenu.meeting_room",
                                },
                            ]}
                        />
                    </div>
                </Box>

                <TabPanel index={0} value={tabValue} p={0}>
                    {/* <Box sx={{ p: 0 }}>
                        <Typography variant="h6" sx={{ p: 3 }}>
                            Meeting Calendar - Coming Soon
                        </Typography>
                    </Box> */}
                    <Box sx={{ p: 0 }}>
                        <Box sx={{ p: 0, width: '100%' }}>
                            <ViewAllRoomsCalendar
                                // FetchDetails={FetchDetails}
                                fetchDetailsContent={FetchDetails}
                                height={500}
                                view={false}
                                employees={employees}
                            />
                        </Box>
                    </Box>

                </TabPanel>

                <TabPanel index={1} value={tabValue} p={0}>
                    <Box sx={{ p: 0, width: '100%' }}>
                        <RoomsManagement
                            SetSelectedMenu={SetSelectedMenu}
                            systemSettings={systemSettings}
                            location={location}
                        />
                    </Box>
                </TabPanel>
            </div>
        </Card>
    );

}

// export default Room;
export default connect(mapStateToProps, mapDispatchToProps)(Room);
